"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "agoraCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _agoraCameraStatusChanged["default"];
  }
});
var _agoraCameraStatusChanged = _interopRequireDefault(require("./agoraCameraStatusChanged"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }